module.exports = __webpack_public_path__ + "img/ep8-7.b4f3d696.png";